import { apiJson } from './apiClient';

export type LeadTier = 'studio' | 'enterprise';

export async function submitTierLead(body: {
  tier: LeadTier;
  name: string;
  email: string;
  organization?: string;
  message?: string;
  source?: string;
}) {
  return apiJson<{
    success: boolean;
    message?: string;
    leadId?: string;
    duplicate?: boolean;
  }>('/api/leads', {
    method: 'POST',
    body: {
      ...body,
      source: body.source || 'pricing_page',
    },
    retry: false,
  });
}

export interface TierLeadRow {
  id: string;
  tier: string;
  name: string;
  email: string;
  organization?: string | null;
  message?: string | null;
  status: string;
  source?: string;
  adminNote?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export async function adminListLeads(status?: string) {
  const q = status ? `?status=${encodeURIComponent(status)}` : '';
  return apiJson<{ success: boolean; leads: TierLeadRow[]; count: number }>(`/api/leads/admin${q}`);
}

export async function adminUpdateLead(id: string, body: { status?: string; adminNote?: string }) {
  return apiJson(`/api/leads/admin/${id}`, {
    method: 'PATCH',
    body,
    retry: false,
  });
}
